<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12 col-md-10">
          <div>
            <h2 class="primary--text">Configurações</h2>
            <v-divider class="my-2"></v-divider>
          </div>
          <v-row class="justify-center justify-md-start">
            <v-col cols="col-12 col-md-5">
              <v-list-item
                @click="toPage(item)"
                class="lightGray mt-3 custom-radius"
                v-for="item in listMenu"
                :key="item.id"
              >
                <v-list-item-content>
                  <v-list-item-title class="gray--text font-bold">{{item.title}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';

export default {
  data() {
    return {
      listMenu: [],
    };
  },
  created() {
    this.getListMenu();
  },
  methods: {
    toPage(item) {
      if (item.content != '') {
        this.$router.push(`others/${item.id}`);
      } else {
        window.open(item.link, '_blank');
      }
    },
    getListMenu() {
      http
        .get('/static_pages/')
        .then((response) => {
          this.listMenu = response.data.results;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="css" scoped>
.w-100 {
  width: 100%;
}

.custom-radius {
  border-radius: 8px;
}

.font-bold {
  font-weight: bold;
}
</style>
